import { render } from "./SettingsIcon.vue?vue&type=template&id=e5e9696c"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SettingsIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5e9696c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5e9696c', __exports__)) {
    api.reload('e5e9696c', __exports__)
  }
  
  module.hot.accept("./SettingsIcon.vue?vue&type=template&id=e5e9696c", () => {
    api.rerender('e5e9696c', render)
  })

}


export default __exports__